/**
 * エラーページコンポーネント
 */
const ErrorPage = ({ errorMessage, onRetry, onBackToSearch }) => {
  return (
    <div className="error-page">
      <h1 className="error-title">エラーが発生しました</h1>
      <p className="error-message">
        {errorMessage || 'PDFの読み込みに失敗しました。'}
      </p>
      <div className="error-button-group">
        <button
          onClick={onRetry}
          className="error-button error-button--retry"
        >
          再試行
        </button>
        <button
          onClick={onBackToSearch}
          className="error-button error-button--back"
        >
          検索画面に戻る
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
